import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationService, NotificationMessage } from '../../../services/notification.service';

@Component({
  selector: 'app-snackbar',
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './snackbar.component.html',
  styleUrl: './snackbar.component.scss'
})
export class SnackbarComponent {
  readonly notificationService = inject(NotificationService);

  removeMessage(id: string): void {
    this.notificationService.removeMessage(id);
  }
}
